export const actionType = {
    UPDATE_SIDEBAR_SELECTED_ITEM: 'UPDATE_SIDEBAR_SELECTED_ITEM',
    RESET_SIDEBAR: 'RESET_SIDEBAR'
};

export const updateSidebarSelectedItem = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_SIDEBAR_SELECTED_ITEM,
            payload: selected
        });
    };
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/sidebar/actions.js